import { render } from "./Filter.vue?vue&type=template&id=38de8d5a&scoped=true"
import script from "./Filter.vue?vue&type=script&lang=js"
export * from "./Filter.vue?vue&type=script&lang=js"

import "./Filter.vue?vue&type=style&index=0&id=38de8d5a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38de8d5a"]])

export default __exports__